// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IAddFormPublishTermsRequest,
  TAddFormPublishTermsModel,
  IMappers,
  TAddFormPublishTermsResponse,
  IAddFormPublishTermsResponse,
} from './types';

export const defaultConfig: TAddFormPublishTermsModel = {
  apiType: 'public',
  assertStatusCodes: [200],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'billing-tariffs',
  pathApi: '/v2/add-form/publish-terms/',
  requestType: 'json',
  responseType: 'json',
} as TAddFormPublishTermsModel;

export function createAddFormPublishTermsModel(parameters: IAddFormPublishTermsRequest): TAddFormPublishTermsModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IAddFormPublishTermsOptions<TResponse200> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200>;
  parameters: IAddFormPublishTermsRequest;
}

export async function fetchAddFormPublishTerms<TResponse200>({
  httpApi,
  config,
  mappers,
  parameters,
}: IAddFormPublishTermsOptions<TResponse200>): Promise<TAddFormPublishTermsResponse | TResponse200> {
  const { statusCode, response, headers } = await httpApi.fetch(createAddFormPublishTermsModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IAddFormPublishTermsResponse);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TAddFormPublishTermsResponse;
}
